// src/pages/restaurant/AddMenu.jsx
import React, { useEffect, useState } from "react";

import api from "../../../utils/api";
import SimpleMenuForm from "../MenuForms/SimpleMenuFormStaff";
import SimpleMenuFormStaff from "../MenuForms/SimpleMenuFormStaff";
import AdvancedMenuFormStaff from "../MenuForms/AdvancedMenuFormStaff";
 

const AddMenuStaff = () => { 
  const [inventory, setInventory] = useState([]);
  const [selectedTab, setSelectedTab] = useState("simple"); // "simple" or "advanced"

  useEffect(() => { 

    api
      .get("restaurant-staff/inventory/get")
      .then((res) => {
        console.log('in',res.data?.items || [])
        setInventory(res.data?.inventory || []);
      })
      .catch(console.error);
  }, []);

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h2 className="text-3xl font-bold mb-6">Add Menu</h2>

      {/* Tabs */}
      <div className="flex space-x-4 mb-6 border-b">
        <button
          className={`px-4 py-2 font-medium ${
            selectedTab === "simple"
              ? "border-b-2 border-blue-600 text-blue-600"
              : "text-gray-500"
          }`}
          onClick={() => setSelectedTab("simple")}
        >
          Simple
        </button>
        <button
          className={`px-4 py-2 font-medium ${
            selectedTab === "advanced"
              ? "border-b-2 border-blue-600 text-blue-600"
              : "text-gray-500"
          }`}
          onClick={() => setSelectedTab("advanced")}
        >
          Advanced
        </button>
      </div>

      {/* Content */}
      {selectedTab === "simple" ? (
        <SimpleMenuFormStaff inventory={inventory} />
      ) : (
        <AdvancedMenuFormStaff   inventory={inventory} />
        //  <AdvancedMenuFormEdit inventory={inventory}  />
      )}
    </div>
  );
};

export default AddMenuStaff;
